
jQuery( function( $ ) {
    $( '.partners__slider' ).slick( {
        slidesToShow: 5,
        cssEase: 'ease-in-out',
        autoplay: true,
        speed: 600,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    } );
} );